export default "__VITE_ASSET__C$y8mVAQ__"